export default __webpack_public_path__ + "static/media/Chasis.2dcaaa61.webp";